import React, { useState } from 'react';
import { Button, ButtonProps } from '@mui/material';
import AddCommentIcon from '@mui/icons-material/AddComment';
import { trackingPrint } from '@app/model';
import { ReportSubmitModal } from '../ReportSubmitModal';

// Allow passing standard Button props to customize the button
interface ReportButtonProps extends Omit<ButtonProps, 'onClick'> {
    buttonText?: string;
}

/**
 * A self-contained button component that triggers the report submission modal.
 */
export const ReportButton: React.FC<ReportButtonProps> = ({ buttonText = '举报', ...rest }) => {
    const [modalOpen, setModalOpen] = useState(false);

    const handleSuccess = () => {
        // A snackbar could be triggered here in a real app.
        console.log('Report submitted successfully.');
        
        // 举报成功埋点
        trackingPrint({params:{
            type:"用户操作",
            title:"举报功能",
            subtitle:"举报-提交成功",
            extra:{
                timestamp: Date.now(),
                buttonText: buttonText
            }
        }});
    };

    const handleClick = () => {
        // 按钮点击埋点
        trackingPrint({params:{
            type:"用户操作",
            title:"举报功能",
            subtitle:"举报-按钮点击",
            extra:{
                timestamp: Date.now(),
                buttonText: buttonText
            }
        }});
        
        setModalOpen(true);
    };

    return (
        <>
            <Button
                variant="contained"
                startIcon={<AddCommentIcon />}
                onClick={handleClick}
                {...rest} // Pass down other props like color, size, etc.
            >
                {buttonText}
            </Button>

            <ReportSubmitModal
                open={modalOpen}
                onClose={() => {
                    // 模态框关闭埋点
                    trackingPrint({params:{
                        type:"模态框操作",
                        title:"举报对话框",
                        subtitle:"对话框-关闭",
                        extra:{
                            timestamp: Date.now(),
                            buttonText: buttonText
                        }
                    }});
                    setModalOpen(false);
                }}
                onSuccess={handleSuccess}
            />
        </>
    );
};
